import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import styles from './WantHelp.module.css';
import Header2 from '../../general/Header2';
import Wrap from '../../general/Wrap';
import Paragraph from '../../general/Paragraph';
import WantHelpForm from './WantHelpForm';
import qrCode from '../../resources/qr.png';

export default class WantHelp extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <Wrap>
                <Row>
                    <Header2>Chci pomáhat</Header2>
                </Row>
                <Row>
                    <Col sm="12" lg="6">
                    <fieldset>
                        <Paragraph>
                            Pomáhat je v silách nás všech. Pokud jste se rozhodli přispět jakýmkoliv darem, odměnou Vám bude radost, že jste svět udělali o kus lepší. Za Váš dar děkujeme a jsme vděční.
                        </Paragraph>
                        <Paragraph>
                            Firemní sponzorství – stanete se partnerem Nadačního fondu při poskytování podpory. Neváhejte nás kontaktovat, máme připravenu zajímavou sponzorskou nabídku.
                        </Paragraph>
                        <Paragraph>
                            Registrujte se mezi dárce Nadace Cesta ke hvězdám. Po připsání daru na náš účet vám zašleme potvrzení, které můžete uplatnit ve vašem účetnictví.
                        </Paragraph>
                        </fieldset>
                    </Col>
                    <Col sm="12" lg="6">
                    <fieldset>
                        <Paragraph>
                            Podpořte nás jednoduchým převodem. Naskenujte QR kód a odešlete dar. Do zprávy pro příjemce prosím uveďte své jméno nebo název firmy.
                        </Paragraph>
                        <img src={qrCode} alt="QR kód pro darování převodem" className={styles.qrCode} />
                        <Paragraph>
                                Pokud budete chtít potvrzení o daru (pro daňové účely), vyplňte prosím dodatečně krátký <WantHelpForm linkText="formulář"/>.
                        </Paragraph>
                        <div className={styles.button}>
                            <WantHelpForm />
                        </div>
                        </fieldset>
                    </Col>
                </Row>
            </Wrap>
        );
    }
}